import { ReactComponent as DowngradeIcon } from './downgrade.svg'
import styles from './DowngradeButton.module.scss'
import { ReactComponent as StarIcon } from './star.svg'

const DowngradeButton = ({ handleClick, canDowngrade }) => (
  <>
    <button className={canDowngrade ? styles.downgradableContainer : styles.container}>
      <StarIcon className={styles.starIcon} />
      {canDowngrade && (
        <DowngradeIcon
          onClick={handleClick}
          className={styles.downgradeIcon}
          data-tip="Downgrade from group to hotel level"
        />
      )}
    </button>
  </>
)

export default DowngradeButton
